import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { llmPromptsKeys } from 'app/queries/llmPrompts/llmPromptsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof llmPromptsKeys.openAiModels>>;

export const createFetchOpenAiModelsQueryFn =
  (call: TCall) =>
  async ({ signal }: TParams) => {
    const models = await call(() => cancelOnSignal(AdminService.getAvailableOpenAiModels(), signal));
    return Array.isArray(models) ? models : [];
  };
